import React from 'react';
import Button from 'jbc-front/components/Button';
import { BulkDownload, BulkPrint } from 'jbc-front/components/icons';
import CommonModal from 'jbc-front/components/CommonModal';
import styles from './BonusReportsDownloadModal.scss';

const BonusReportsDownloadModal = props => {
  const { isOpen, hideModal, downloadPdf, downloadZip } = props;
  const header = '明細一括出力';

  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <React.Fragment>
        <CommonModal.Header hideModal={hideModal}>{header}</CommonModal.Header>
        <CommonModal.Body>
          <form>
            <p>明細一括データをダウンロード、印刷のどちらかを選択してください。</p>
            <div className={styles.button_box}>
              <Button onClick={downloadZip} className={styles.button_frame}>
                <BulkDownload size={50} />
                <p>データをダウンロードする</p>
              </Button>
              <Button onClick={downloadPdf} className={styles.button_frame}>
                <BulkPrint size={50} />
                <p>データを印刷する</p>
              </Button>
            </div>
          </form>
        </CommonModal.Body>
      </React.Fragment>
    </CommonModal>
  );
};

export default BonusReportsDownloadModal;
